const MODEL_NAME = 'activty'
export default [
  {
    path: `/${MODEL_NAME}/darenBX`,
    name: 'activtyBX',
    component: () =>
      import(/* webpackChunkName: "activty-daren-bx" */ '@pages/activty/darenBX/index.vue')
  },
  {
    path: `/${MODEL_NAME}/bill`,
    name: 'activtyBill',
    component: () =>
      import(/* webpackChunkName: "activty-sign-in-bill" */ '@pages/activty/sign-in/bill.vue')
  },
  {
    path: `/${MODEL_NAME}/sign-in`,
    name: 'activtySignIn',
    component: () =>
      import(/* webpackChunkName: "activty-sign-in" */ '@pages/activty/sign-in/index.vue')
  },
  {
    path: `/${MODEL_NAME}/new-user`,
    name: 'activtyNewUser',
    component: () =>
      import(/* webpackChunkName: "activty-new-user" */ '@pages/activty/new-user/index.vue')
  },
  {
    path: `/${MODEL_NAME}/douyin-download`,
    name: 'activtyDouyiDownload',
    component: () =>
      import(/* webpackChunkName: "activty-douyin" */ '@pages/activty/douyin/index.vue')
  },
  {
    path: `/${MODEL_NAME}/iphone12-download`,
    name: 'activtyIphone12Download',
    component: () =>
      import(/* webpackChunkName: "activty-iphone12" */ '@pages/activty/iphone12/index.vue')
  },
  {
    path: `/${MODEL_NAME}/act618-download`,
    name: 'activtyAct618Download',
    component: () =>
      import(/* webpackChunkName: "activty-iphone12" */ '@pages/activty/act618/index.vue')
  },
  {
    path: `/${MODEL_NAME}/new-media-download`,
    name: 'newMediaDownload',
    component: () =>
      import(/* webpackChunkName: "new-media-download" */ '@pages/activty/new-media/index.vue')
  },
  {
    path: `/${MODEL_NAME}/new-media-download/sub-index`,
    name: 'newMediaDownloadSubIndex',
    component: () =>
      import(
        /* webpackChunkName: "new-media-download-sub-index" */ '@pages/activty/new-media/subIndex.vue'
      )
  }
]
